/* eslint-disable max-classes-per-file */
import moment from 'moment'
import * as _ from 'lodash'

/* eslint-disable max-classes-per-file */
export class MInspector {
    name: string

    phone: string

    address: string

    distance: string

    id: string

    email: string

    inspectorId: string

    constructor(inspector: any) {
        this.name = inspector?.name || ' - '
        this.phone = inspector?.phone || ' - '
        this.address = inspector?.address || ' - '
        this.distance = inspector?.distance || 0
        this.id = inspector?.code || ' - '
        this.email = inspector?.email || ' - '
        this.inspectorId = inspector?.id
    }
}

// export class MInspection {
//     code: string

//     id: string

//     inspectStatus: string

//     inspectorId: string

//     name: string

//     score: string

//     status: string

//     constructor(inspection: MInspection) {
//         this.code = inspection?.code
//         this.id = inspection?.id
//         this.inspectStatus = inspection?.inspectStatus
//         this.inspectorId = inspection?.inspectorId
//         this.name = inspection?.name
//         this.score = inspection?.score
//         this.status = inspection?.status
//     }
// }

export class MInspection {
    code: string

    expiredDate: string

    status: string

    // inspection: MInspection

    id: string

    constructor(inspection: any) {
        this.code = inspection?.code
        this.expiredDate = inspection?.expiredDate
            ? moment(inspection?.expiredDate).format('DD/MM/YYYY')
            : ' - '
        // this.status =
        //     inspection?.status === 'COMPLETED'
        //         ? inspection?.inspection?.inspectStatus
        //         : inspection?.status
        this.status = inspection?.inspectStatus
        // this.inspection = new MInspection(inspection?.inspection)
        this.id = inspection?.id
    }
}

export class MInspectionAnswer {
    id: string

    inspectionId: string

    inspectionQuestionId: string

    name: string

    constructor(answer: MInspectionAnswer) {
        this.id = answer?.id
        this.inspectionId = answer?.inspectionId
        this.inspectionQuestionId = answer?.inspectionQuestionId
        this.name = answer?.name
    }
}

export class MInspectionChildQuestion {
    code: string

    description: string

    id: string

    inspectionFormId: string

    name: string

    parentId: string

    questionType: string

    sequence: number

    status: string

    type: string

    answerOptions: MInspectionAnswer[]

    answers: MInspectionAnswer[]

    constructor(childQuestion: MInspectionChildQuestion) {
        this.code = childQuestion?.code
        this.description = childQuestion?.description
        this.id = childQuestion?.id
        this.inspectionFormId = childQuestion?.inspectionFormId
        this.name = childQuestion?.name
        this.parentId = childQuestion?.parentId
        this.questionType = childQuestion?.questionType
        this.sequence = childQuestion?.sequence
        this.status = childQuestion?.status
        this.type = childQuestion?.type
        this.answerOptions = childQuestion?.answerOptions?.length
            ? childQuestion?.answerOptions?.map(
                  (item: MInspectionAnswer) => new MInspectionAnswer(item)
              )
            : []
        this.answers = childQuestion?.answers?.length
            ? childQuestion?.answers?.map(
                  (item: MInspectionAnswer) => new MInspectionAnswer(item)
              )
            : []
    }
}

export class MInspectionQuestion {
    description: string

    id: string

    inspectionFormId: string

    name: string

    questionType: string

    sequence: number

    status: string

    type: string

    child: MInspectionChildQuestion[]

    constructor(question: MInspectionQuestion) {
        this.description = question?.description
        this.id = question?.id
        this.inspectionFormId = question?.inspectionFormId
        this.name = question?.name
        this.questionType = question?.questionType
        this.sequence = question?.sequence
        this.status = question?.status
        this.type = question?.type
        this.child = question?.child?.length
            ? question?.child?.map(
                  (item: MInspectionChildQuestion) =>
                      new MInspectionChildQuestion(item)
              )
            : []
    }
}
class MInspectionForm {
    code: string

    description: string

    id: string

    inspectorId: string

    name: string

    questions: MInspectionQuestion[]

    status: string

    constructor(form: MInspectionForm) {
        const sortedQuestions = form?.questions?.length
            ? _.sortBy(form?.questions, ['sequence'])
            : []
        this.code = form?.code
        this.description = form?.description
        this.id = form?.id
        this.inspectorId = form?.inspectorId
        this.name = form?.name
        this.questions = sortedQuestions?.length
            ? sortedQuestions?.map(
                  (item: MInspectionQuestion) => new MInspectionQuestion(item)
              )
            : []
        this.status = form?.status
    }
}

export class MInspectionDetail extends MInspection {
    inspector: MInspector

    form: any

    inspection: any

    constructor(inspectionDetail: MInspectionDetail) {
        super(inspectionDetail)
        this.inspector = inspectionDetail?.inspector
        this.form = inspectionDetail?.form
            ? new MInspectionForm(inspectionDetail?.form)
            : null
        // this.inspection = new MInspection(inspectionDetail?.inspection)
    }
}
